<template>
    <div class="p-content" v-if="!userAgent">
        <div class="p-type  center" >
            <div class="type" ref="type" v-for="item of limit_exclusive" :key="item.id">
                <p>{{item.title_one}}<br>{{item.title_two}}</p>
                <div class="t-list" v-for="items of item.goods" :key="items.id">
                    <p>{{items.name}}</p>
                    <p>{{items.spec}}</p>
                    <p>数量：{{items.good_num}}</p>
                </div>
                <button  @click="handleDetail(item.id,item.title_one,item.title_two)">
                    <p>查看详情</p>
                    <i class="iconfont iconxiangyoujiantou_quan"></i>
                </button>
            </div>
        </div>
        
    </div>
    <!-- 移动端 -->
    <div class="p-content1" v-else>         
         <div class="p-type1 center" >
            <div class="type1" v-for="item of limit_exclusive" :key="item.id">
                <p>{{item.title_one}}<br>{{item.title_two}}</p>
                <div class="t-list1" v-for="items of item.goods" :key="items.id">
                    <p>{{items.name}}</p>
                    <p>{{items.spec}}</p>
                    <p>数量：{{items.good_num}}</p>
                </div>
                <button @click="handleDetail(item.id,item.title_one,item.title_two)">
                    <p >查看详情</p>
                    <i class="iconfont iconxiangyoujiantou_quan"></i>
                </button>
            </div>
        </div>       
    </div>
</template>

<script>
    export default {
       name:"PackageItem",
       data() {
           return {     
            sea_exclusive:[],
            limit_exclusive:[]
           }
       },
       
       mounted(){
          this.$http.get('api/index/index').then(res=>{
              this.sea_exclusive=res.data.data.sea_exclusive 
              this.limit_exclusive=this.sea_exclusive.slice(0,5)                  
          }) 
       },
       methods: {
           handleDetail(id,title_one,title_two){
               this.$router.push(`/detail?id=${id}&title_one=${title_one}&title_two=${title_two}`)
           },
       },
    }
</script>

<style scoped>
.center{
    margin: 0 auto;
}

.p-type{
    width: 80%;
    text-align: center;
    justify-content: center;
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(5,18%);
}
.type{
    border: 1.5px solid #92080F;
    text-align: center;
    border-top-left-radius: 150px;
    border-top-right-radius: 150px;
    border-bottom-left-radius: 150px;
    border-bottom-right-radius: 150px;
    margin-right: 3%;

}
.type>p{
    color: #92080F;
    font-weight: bold;
    border-bottom: 1.5px solid  #656565;
    width: 80%;
    font-size: 18px;
    padding: 15px 0;
    margin: 0 auto;
    line-height: 25px;
}
.t-list{
    font-size: 8px;
    border-bottom: 1px solid  #656565;
    width: 80%;
    text-align: left;
    line-height: 20px;
    color: #6B6B6B;
    margin: 0 auto;
}
.t-list>p:nth-child(1){
    font-weight: 600;
}
.t-list>p:nth-child(2){
    font-size: 8px;
}
.type button{
    background: black;
    padding: 4%;
    border-radius: 50%;
    color: white;
    margin: 10px 0;
    font-size:16px;
    outline: none;
    cursor: pointer;
}
.type button i{
   
    font-size: 40px;
    border-radius: 50%;
}
.p-content{
    width:100%;
    background:rgba(255,255,255,1);
    margin: 3% 0;
    text-align: center;
}


/* 移动端 */
.p-content1{
    margin: 3% 0;
    text-align: center;   
}
.p-type1{
    overflow-x: auto;
    overflow-y: hidden;
    width: 90%;
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: space-between;
}
.type1{
    width:45%;
    border: 1.5px solid #92080F;
    text-align: center;
    border-top-left-radius: 100px;
    border-top-right-radius: 100px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    margin-bottom: 20px;
    margin:0 2%;
    flex-shrink: 0;
}
.type1>p{
    color: #92080F;
    font-weight: bold;
    border-bottom: 1.5px solid  #656565;
    width: 80%;
    margin: 10% auto 0;
    font-size: 15px;
    padding: 6px 0;
}
.type1 button{
    background: black;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    color: white;
    margin: 10px 0;
    font-size:10px;
    outline: none;
    padding: 15px 0 ;
}
.type1 button i{
    font-size: 25px;
    border-radius: 50%;
    display: inline-block;
}
.t-list1{
    font-size: 8px;
    border-bottom: 1px solid  #656565;
    width: 80%;
    text-align: left;
    margin: 0 auto;
    line-height: 18px;
    color: #6B6B6B;
}
.t-list1>p:nth-child(1){
    font-weight: 600;
}
.t-list1>p:nth-child(2){
    font-size: 8px;
}
</style>